module.exports = __webpack_public_path__ + "resources/img/main07.10535eaed0cbca0b53c2efb80cfdb5fe.png";